export default __webpack_public_path__ + "static/media/d3-250-min.e6a8930a.png";